import React from 'react';
import { proveItContent } from '../rich-content/prove-it-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const ProveItDetailPage = () => {
  return <AutomaticPageBuilder content={proveItContent} />;
};

export default ProveItDetailPage;
